"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListMembersQuerySchema = exports.UpdateMemberBodySchema = exports.ListMembersResponseSchema = exports.UpdateMemberResponseSchema = exports.GetMemberResponseSchema = exports.MemberSchema = exports.MemberFields = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
const common_1 = require("../common");
exports.MemberFields = {
    user: common_1.UserSchema,
    role: ruby_1.TeamRoleSchema,
};
exports.MemberSchema = (0, core_1.StrictObject)({
    ...exports.MemberFields,
});
/**
 * Responses
 */
exports.GetMemberResponseSchema = exports.MemberSchema;
exports.UpdateMemberResponseSchema = exports.MemberSchema;
exports.ListMembersResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.GetMemberResponseSchema);
/**
 * Body
 */
// Note there is not creation of a member, you either use update or create an invitation
exports.UpdateMemberBodySchema = (0, core_1.StrictObject)({
    role: typebox_1.Type.Optional(ruby_1.TeamRoleSchema),
});
/**
 * Parameters
 */
exports.ListMembersQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({});
